import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { WatchlistVM } from './watchlist.entity';

export const watchlistActions = createActionGroup({
  source: 'Watchlist',
  events: {
    'Set Loading': props<{ loading: boolean }>(),
    'Load Watchlist': props<{ force: boolean }>(),
    'Add Watchlist Item': props<{ isin: string }>(),
    'Remove Watchlist Item': props<{ isin: string }>(),
    'Save Watchlist': emptyProps(),
    'Save Watchlist Item': props<{ isin: string }>(),
    'Reorder Watchlist Item': props<{ from: number; to: number }>(),
    'Update Watchlist Item Note': props<{ isin: string; note: string }>(),
    'Update Watchlist Item Entry Quote': props<{ isin: string; entryQuote: number; basedOnEntry: boolean }>(),
    'Subscribe To Watchlist Quotes': props<{ basedOnEntry: boolean }>(),
    'Subscribe To Watchlist Quotes Failure': emptyProps(),
    'Unsubscribe From Watchlist Quotes': emptyProps(),
    'Subscribe To Watchlist Item Quote': props<{ isin: string; basedOnEntry: boolean }>(),
    'Unsubscribe From Watchlist Item Quote': props<{ isin: string }>(),
    'Watchlist Performance Calculated': props<{ watchlist: WatchlistVM[] }>(),
    'Set Watchlist Categories': props<{ categories: string[] }>(),
  },
});

export const watchlistApiActions = createActionGroup({
  source: 'Watchlist API',
  events: {
    'Load Watchlist Success': props<{ watchlist: WatchlistVM[] }>(),
    'Load Watchlist Failure': props<{ error: HttpErrorResponse }>(),
    'Add Watchlist Item Success': props<{ item: WatchlistVM }>(),
    'Add Watchlist Item Failure': props<{ error: HttpErrorResponse }>(),
    'Remove Watchlist Item Success': props<{ isin: string }>(),
    'Remove Watchlist Item Failure': props<{ error: HttpErrorResponse }>(),
    'Save Watchlist Success': emptyProps(),
    'Save Watchlist Failure': props<{ error: HttpErrorResponse }>(),
    'Save Watchlist Item Success': emptyProps(),
    'Save Watchlist Item Failure': props<{ error: HttpErrorResponse }>(),
  },
});
